{
  "responseShape": "การตอบสนองของเซิร์ฟเวอร์ไม่ตรงกับรูปแบบที่คาดไว้ — โปรดรีเฟรช",
  "badRequest": "คำขอไม่ถูกต้อง โปรดตรวจสอบข้อมูลที่ป้อน",
  "forbidden": "คุณไม่มีสิทธิ์ดำเนินการนี้",
  "facilityRequired": "เลือกสถานพยาบาลที่ส่วนหัวเพื่อใช้งานโมดูลนี้",
  "notFound": "ไม่พบทรัพยากร",
  "conflict": "ทรัพยากรมีอยู่แล้ว",
  "validation": "ข้อผิดพลาดในการตรวจสอบ",
  "tooManyRequests": "คำขอมากเกินไป โปรดลองใหม่อีกครั้งภายหลัง",
  "serverError": "เซิร์ฟเวอร์ผิดพลาด โปรดลองใหม่อีกครั้งภายหลัง",
  "unexpected": "เกิดข้อผิดพลาดที่ไม่คาดคิด",
  "network": "ข้อผิดพลาดของเครือข่าย โปรดตรวจสอบการเชื่อมต่อของคุณ",
  "requestSetup": "เกิดข้อผิดพลาด โปรดลองอีกครั้ง",
  "sessionExpired": "เซสชันของคุณหมดอายุแล้ว กรุณาเข้าสู่ระบบอีกครั้ง"
}
